import { render } from "./STDSDC01C08ProcessingConfirmModal.vue?vue&type=template&id=64581e96&scoped=true"
import script from "./STDSDC01C08ProcessingConfirmModal.vue?vue&type=script&lang=js"
export * from "./STDSDC01C08ProcessingConfirmModal.vue?vue&type=script&lang=js"

import "./STDSDC01C08ProcessingConfirmModal.vue?vue&type=style&index=0&id=64581e96&scoped=true&lang=css"

import exportComponent from "D:\\TDS\\40_製造(M)\\99_電帳法_USE\\Tatsuzin_filemanage\\vue\\tdsvue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64581e96"]])

export default __exports__